import { apiClient } from "./client";

export interface PlanHour {
  hour: number;
  power_kw: number | string;
  volumes: Record<string, number | string>;
}

export interface Plan {
  id: string;
  tenant_id: string;
  plan_date: string;
  last_updated_at: string;
  last_updated_by: string | null;
  submitted_at: string | null;
  hours: PlanHour[];
}

export interface PlanHourWrite {
  power_kw: number;
  volumes: Record<string, number>;
}

/** Результат публікації в Telegram-канал разом із подачею (FR-TGC-02). */
export interface ChannelPostStatus {
  ok: boolean;
  is_edit: boolean | null;
  error: string | null;
}

export type PlanSubmitResult = Plan & { channel_post: ChannelPostStatus | null };

export interface ChannelPostResult {
  sent_at: string;
  is_edit: boolean;
}

export type CopyFromSource = "yesterday" | "weekly_avg";

export const plansApi = {
  get: (planDate: string) =>
    apiClient.get<Plan | null>(`/plans/${planDate}`).then((r) => r.data),

  putHour: (planDate: string, hour: number, body: PlanHourWrite) =>
    apiClient
      .put(`/plans/${planDate}/hour/${hour}`, body)
      .then((r) => r.data),

  copyFrom: (planDate: string, source: CopyFromSource) =>
    apiClient
      .post<Plan>(`/plans/${planDate}/copy-from`, null, { params: { source } })
      .then((r) => r.data),

  submit: (planDate: string, sendToChannel = false) =>
    apiClient
      .post<PlanSubmitResult>(`/plans/${planDate}/submit`, { send_to_channel: sendToChannel })
      .then((r) => r.data),

  /** Пост плану в канал; `force` — надіслати, навіть якщо план не змінився. */
  channelPost: (planDate: string, force = false) =>
    apiClient
      .post<ChannelPostResult>(`/plans/${planDate}/channel-post`, { force })
      .then((r) => r.data),

  unsubmit: (planDate: string) =>
    apiClient.post<Plan>(`/plans/${planDate}/unsubmit`).then((r) => r.data),
};
